<!-- src/components/ChangePassword.vue -->
<template>
    <div>
        <div v-if="visible && !requestOtpForUpdatingPassword" class="modal-overlay">
            <div class="modal-content">
                <div class="modal-header">
                    <i class="fa fa-lock icon"></i>
                    <h2>{{ title }}</h2>
                </div>
                <div class="modal-body">
                    <base-input :label="`New Password`">
                        <a-input
                        :type="passwordType"
                        placeholder="New Password"
                        v-model="formData.password"
                        @input="onPasswordInput"
                        >
                        <template #addonAfter>
                        <i
                            :class="['fa', passwordType === 'password' ? 'fa-eye' : 'fa-eye-slash']"
                            aria-hidden="true"
                            @click="viewPassword"
                            />
                        </template>
                        </a-input>
                        <br />
                        <br />
                        <div class="condition-text">
                        Password must contain:
                        <ul>
                            <li
                            :class="[
                                'condition-text',
                                {
                                passed:
                                    $v.formData.password.minLength &&
                                    $v.formData.password.maxLength,
                                },
                            ]"
                            >
                            <div>Should be 8-30 characters long</div>
                            </li>
                            <li
                            :class="[
                                'condition-text',
                                {
                                passed: $v.formData.password.alphaNumSpecial,
                                },
                            ]"
                            >
                            <div>Should contain alphabetical character</div>
                            </li>
                            <li
                            :class="[
                                'condition-text',
                                {
                                passed: $v.formData.password.hasNum,
                                },
                            ]"
                            >
                            <div>Should contain Numeric character</div>
                            </li>
                            <li
                            :class="[
                                'condition-text',
                                {
                                passed: $v.formData.password.hasSpe,
                                },
                            ]"
                            >
                            <div>Should contain special character (!@#$%^&*)</div>
                            </li>
                        </ul>
                        </div>
                    </base-input>
                    <base-input :label="`Confirm Password`">
                        <a-input
                        :type="rePasswordType"
                        placeholder="Confirm Password"
                        v-model="formData.repassword"
                        @input="onPasswordInput"
                        >
                        <template #addonAfter>
                            <i
                            :class="['fa', passwordType === 'password' ? 'fa-eye' : 'fa-eye-slash']"
                            aria-hidden="true"
                            @click="viewConPassword"
                            />
                        </template>
                        </a-input>
                        <div v-if="$v.formData.repassword.$dirty" class="text-danger">
                        <div class="error" v-if="!$v.formData.repassword.required">
                            Field is required
                        </div>
                        <div class="error" v-if="!$v.formData.repassword.isSame">
                            Passwords must match
                        </div>
                        </div>
                    </base-input>
                </div>
                <div class="modal-footer" v-if="!requestOtpForUpdatingPassword">
                    <button class="btn-change" @click="handleChangePassword" :disabled="isChangeButtonDisabled">
                        Change
                    </button>
                </div>
            </div>
        </div>
        <a-modal
            v-model="otpRequestModal"
            title="OTP Verification Form"
            :ok-button-props="{
            style: { backgroundColor: '#F15A22', borderColor: '#F15A22', color: '#fff' }
            }"
            @ok="
            () => {
                verifyOtp();
            }
        "
            @cancel="resetOtpTimers"
            :cancel-button-props="{
            style: { backgroundColor: '#f2f2f2', borderColor: '#f2f2f2', color: '#333333' }
            }"
        >

            <div v-if="requestOtpForUpdatingPassword">
                <p>Please enter the OTP sent to your <b>Mobile Number</b></p>
                <small
                >This authentication is to verify that you are updating your
                data.</small
                >
                <!-- <a-input
                v-model="otpCode"
                placeholder="Enter received OTP from mobile number"
                /> -->

                <a-input-search
                    placeholder="Enter received OTP from mobile number"
                    v-model="otpCode"
                    @search="resendOtp"
                >
                <a-button
                    class="resend-btn"
                    slot="enterButton"
                    :disabled="!canResendSmsOtp"
                    v-if="resendSmsTimer > 0"
                >
                    Resend in {{ resendSmsTimer }}(s)
                </a-button>
                <a-button
                    class="resend-btn"
                    slot="enterButton"
                    :disabled="!canResendSmsOtp || resendingSmsOtp"
                    v-else
                >
                    Resend OTP Request
                </a-button>
                </a-input-search>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import HTTPRequest from '../controllers/httpRequest';
import { getClpSitePageSettings } from '@/utils/clpSiteSettings';

function conditionalMinLength(length) {
  return function (value) {
    // If empty, skip validation
    if (!value) return false;
    return minLength(length)(value);
  };
}

function alphaNumSpecial(value) {
  if (!value) return false;
  return /^[A-Za-z0-9!@#$%^&*]+$/.test(value);
}

export default {
    props: {
        data: {
            type: Object,
        },
        visible: Boolean,
        title: {
            type: String,
            default: 'Change Password',
        }
    },
    data() {
        return {
            formData: {
                password: null,
                repassword: null,
            },
            passwordType: 'password',
            rePasswordType: 'password',
            minLength: 8,
            maxLength: 30,
            isPasswordValid: false,
            requestOtpForUpdatingPassword: false,
            otpRequestModal: false,
            otpCode: null,
            canResendSmsOtp: false,
            resendingSmsOtp: false,
            resendSmsTimer: 0,
            verifiedOtp: false,
            clpSitePageSettings: {},
            otpConfigDuration: { refresh: { interval: 0 } }
        };
    },
    validations() {
    const validation = {
      formData: {
        password: {
          required,
          minLength: conditionalMinLength(this.minLength),
          maxLength: maxLength(this.maxLength),
          alphaNumSpecial: (value) => alphaNumSpecial(value),
          hasNum: (value) => /\d/.test(value) && !/^\d+$/.test(value),
          hasSpe: (value) => {
            if (typeof value !== 'string') return false;
            const specialChars = '!@#$%^&*';
            const escapedChars = specialChars.replace(
              /[-[\]/{}()*+?.\\^$|]/g,
              '\\$&'
            );
            const containsSpecialChar = new RegExp(`[${escapedChars}]`).test(
              value
            );

            return containsSpecialChar;
          },
        },
        repassword: {
          required,
          isSame: (value) => this.formData.password === value,
        },
      },
    };
    return validation;
  },
  methods: {
    viewPassword() {
      if (this.passwordType === 'password') {
        this.passwordType = 'text';
      } else {
        this.passwordType = 'password';
      }
    },
    viewConPassword() {
      if (this.rePasswordType === 'password') {
        this.rePasswordType = 'text';
      } else {
        this.rePasswordType = 'password';
      }
    },
    onPasswordInput() {
      this.$v.formData.$touch(); // So the validations react as you type
    },
    validate() {
      console.log('Validate data');
      this.$v.formData.$touch();
    },
    resendOtp: async function () {
      if (this.canResendSmsOtp) {
        this.resendingSmsOtp = true;
        const response = await HTTPRequest.postRequest(
            '/api/v2/clp_otp_verifications/update_member'
        );

        if (response.member_id) {
          this.otp = response;
          this.otpGenerated = true;

          this.resendSmsTimer = this.otpConfigDuration?.refresh?.interval;
          this.canResendSmsOtp = false;
        } else {
          this.otpGenerated = false;
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.resendingSmsOtp = false;
      }
    },
    resetOtpTimers: function () {
      this.canResendSmsOtp = false;
      this.resendingSmsOtp = false;
      this.resendSmsTimer = this.otpConfigDuration?.refresh?.interval; // in seconds
      this.smsTimer = null;
      this.canResendEmailOtp = false;
      this.resendingEmailOtp = false;
      this.resendEmailTimer = 60; // in seconds
      this.emailTimer = null;
      this.otp = {};
      this.otpEmail = {};
      this.otpEmailCode = null;
      this.otpCode = null;
    },
    startSmsTimer: function () {
      this.smsTimer = setInterval(() => {
        this.resendSmsTimer--;

        if (this.resendSmsTimer <= 0) {
          this.resendSmsTimer = 0;
          this.canResendSmsOtp = true;
        }
      }, 1000);
    },  
    /** If any data is updated, this is logic for requesting OTP */
    requestOtpForUpdating: async function () {
      // If any data is updated, run this method.
      if (!this.otpGenerated) {
        this.formSubmitting = true;
        const response = await HTTPRequest.postRequest(
            '/api/v2/clp_otp_verifications/update_member'
        );

        if (response.member_id) {
          this.otp = response;
          this.otpRequestModal = true;
          this.otpGenerated = true;
        } else {
          this.otpGenerated = false;
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.formSubmitting = false;
      } else {
        this.otpRequestModal = true;
      }
    },
    async handleChangePassword(){
        this.requestOtpForUpdatingPassword = true;
        this.requestOtpForUpdating();
        this.startSmsTimer();
    },
    async verifyOtp() {
      const endpointVerifyOtp = '/api/v2/clp_member_accounts/update_verify_otp';
      const otp = this.otpCode;
      if (otp === null) {
        this.verifiedOtp = false;
      }
      const memberId = this.data.id;
      const mobileNumber = this.data.mobile_no;
      const source = this.otp.source;
      const payload = {
        otp: {
          member_id: memberId,
          otp_code: otp,
          source: source,
          mobile_number: mobileNumber
        },
      };

      const verifyOtpResult = await HTTPRequest.postRequest(
        endpointVerifyOtp,
        payload
      );
      console.log('verifyOtpResultz', verifyOtpResult)

      const { error } = verifyOtpResult;
      if (error) {
        this.verifiedOtp = true;
        this.$notification.error({
          message: error
        });
        return 0;
      }
      const { is_valid: isValid, valid_until: validUntil } =
        verifyOtpResult.data;

      if (isValid === true) {
        this.otpValidity = validUntil;
        this.verifiedOtp = true;
        this.onChangePassword();
      } else {
        this.verifiedOtp = false;
      }
     
    },
    async onChangePassword(){
      if(this.verifiedOtp){
        const response = await HTTPRequest.postRequest(
            '/api/v2/clp_member_accounts/change_password',
            {
              password: this.formData.password,
              confirm_password: this.formData.repassword,
              otp_code: this.otpCode,
              source: this.otp.source,
              mobile_number: this.data.mobile_no
            }
        );

        if (response.data) {
          this.$notification.success({
            message: 'Password has been updated.'
          });

          this.otpRequestModal = false;
          this.otp = {};
          this.otpCode = null;
          this.requestOtpForUpdatingPassword = false;
          this.visible = false;
          setTimeout(()=>{
            window.location.reload();
          }, 1000)
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }
      }else{
        this.$notification.error({
          message: 'Invalid OTP'
        });
      }
    }
  },
  computed: {
    isChangeButtonDisabled() {
      const { password, repassword } = this.$v.formData;

      return (
        !password.$dirty ||
        !password.required ||
        !password.minLength ||
        !password.maxLength ||
        !password.alphaNumSpecial ||
        !password.hasNum ||
        !password.hasSpe ||
        !repassword.required ||
        !repassword.isSame
      );
    }
  },
  async created() {
    this.clpSitePageSettings = await getClpSitePageSettings();
    const _otpConfigDuration = this.clpSitePageSettings.otpConfigDuration
    if(_otpConfigDuration){ 
      this.otpConfigDuration = JSON.parse(_otpConfigDuration); 
      this.resendSmsTimer = this.otpConfigDuration?.refresh?.interval;
    }
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

.modal-content {
  background: white;
  padding: 1rem;
  border-radius: 12px;
  max-width: 450px;
  width: 100%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

.modal-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.modal-header .icon {
  font-size: 3rem;
  color: #F15A22;
}

.modal-header h2 {
  margin: 0;
  font-weight: bold;
  color: #F15A22;
}

.modal-body {
  font-weight: bold;
  color: #F15A22;
}

.modal-footer {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.btn-change {
  background-color: #F15A22;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 6px;
  cursor: pointer;
}

.condition-text {
  font-size: 14px;
  color: gray;
}

.passed {
  font-size: 14px;
  color: green;
}

.error {
  font-size: 14px;
  color: red;
}

.resend-btn {
  background-color: #f2f2f2;
  color: #333333;
  border: 1px solid #cccccc;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.resend-btn:hover {
  background-color: #e6e6e6;
  color: #000000;
}

.resend-btn:active {
  background-color: #d9d9d9;
}

.h3-text {
  color: #003A90;
}

.btn-change:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>
